module.exports = __webpack_public_path__ + "ff56fa86792bfeb4d4a09beb15a2614f.fbx";